import React from "react";
import { Carousel } from "react-bootstrap";
import './Carousel.css'
import "bootstrap/dist/css/bootstrap.min.css";

interface CaruselProps {
    style: any
    operator: string
}

const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;

const BENGABET_ZM_LOGOS = [
    { src: "/assets/operators/mtn.png", label: "MTN" },
    { src: "/assets/operators/airtel.png", label: "Airtel" },
    { src: "/assets/operators/zamtel.png", label: "Zamtel" },
];

const BootstrapCarousel: React.FC<CaruselProps> = ({ style, operator }) => {
    const logos = [
        "/assets/operators/airtel.png",
        "/assets/operators/MTN.png",
        "/assets/operators/at.png",
        "/assets/operators/celtiis.png",
        "/assets/operators/halo.png",
        "/assets/operators/mixx.png",
        "/assets/operators/momo.png",
        "/assets/operators/movitel.png",
        "/assets/operators/movo.png",
        "/assets/operators/mpesa.png",
        "/assets/operators/orangemoney.png",
        "/assets/operators/telecel.png",
        "/assets/operators/tnm.png",
        "/assets/operators/vodacom.png",
        "/assets/operators/wave.png",
        "/assets/operators/zamtel.png",
    ];

    const chunkSize = 4;
    const chunks = Array.from({ length: Math.ceil(logos.length / chunkSize) }, (_, i) =>
        logos.slice(i * chunkSize, i * chunkSize + chunkSize)
    );

    if (operator === "bengabet-zm") {
        return (
            <div
                className="carousel-container mt-3"
                style={{ backgroundColor: style.colors.blockTitleBgColor }}
            >
                <div className="d-flex justify-content-center align-items-center bengabet-static-list">
                    {BENGABET_ZM_LOGOS.map((logo, idx) => (
                        <img
                            key={idx}
                            src={toAbsoluteUrl(logo.src)}
                            alt={logo.label}
                            className="carousel-logo mx-2"
                            style={{
                                border: `.5px solid ${style.colors.fontColor}`,
                                borderRadius: '4px',
                            }}
                        />
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div
            className="carousel-container mt-3"
            style={{ backgroundColor: style.colors.blockTitleBgColor }}
        >
            <Carousel controls={false} indicators={false} interval={3000} pause={false}>
                {chunks.map((group, index) => (
                    <Carousel.Item key={index}>
                        <div className="d-flex justify-content-center align-items-center">
                            {group.map((src, idx) => (
                                <img
                                    key={idx}
                                    src={`${toAbsoluteUrl(src)}`}
                                    alt={`Logo-${idx}`}
                                    className="carousel-logo mx-2"
                                    style={{
                                        border: `.5px solid ${style.colors.fontColor}`,
                                        borderRadius: '4px'
                                    }}
                                />
                            ))}
                        </div>
                    </Carousel.Item>
                ))}
            </Carousel>
        </div>
    );
};

export default BootstrapCarousel;